var _circle, _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBadgeAditionalDelivery(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11,
    fill: "#D9FFD9",
    stroke: "#fff",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.138 5.529c.26.26.26.682 0 .942l-3.62 3.62a.733.733 0 01-1.037 0l-1.62-1.62a.667.667 0 11.944-.942L7 8.724l3.195-3.195c.26-.26.683-.26.943 0z",
    fill: "green"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 8h-2.58a.1.1 0 01-.07-.17l1.133-1.134a.1.1 0 01.07-.03H14.6c.405 0 .733.329.733.734V9h1.612a.8.8 0 01.565.234l1.922 1.922a.8.8 0 01.235.566V14.6a.733.733 0 01-.734.733H18a2 2 0 01-4 0h-3.333a2 2 0 01-4 0H5.4a.733.733 0 01-.733-.733V10c0-.06.071-.083.114-.04l1.19 1.19a.1.1 0 01.029.07V14h1.176a1.995 1.995 0 012.982 0H14V8zm1.333 4.667v-2.334h1.39l1.61 1.61v.724h-3zm-6.666 3.466a.8.8 0 100-1.6.8.8 0 000 1.6zm8.133-.8a.8.8 0 11-1.6 0 .8.8 0 011.6 0z",
    fill: "green"
  })));
}

export default SvgBadgeAditionalDelivery;